import React from "react"
import css from "./index.module.css"
import { Spin } from "antd"

const Loading = ({ title, empty, ...props }) => {
  return (
    <div className={css.container}>
      <div className={css.loading}>
        <Spin
          className={css.spin}
          size="large"
          tip={empty ? "" : `Loading ${title}`}
        />
      </div>
    </div>
  )
}

export default Loading
